<template>
    <div class="etusivu">
        <h1>{{ $t("App.Header.Etusivu") }}</h1>
        <p><span class="etusivu-app-name">{{ $t("App.Etusivu.AppName") }} </span>{{ $t("App.Etusivu.Content") }}</p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"

    @Component
    export default class MobileFrontPageInfo extends Vue {}
</script>
